// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"f1011779","306":"6add2221","488":"a4087672","616":"488d248e","632":"0084c2c8","665":"52425fe8","732":"bcadab7f","739":"b3a5f6c9","817":"e8b084a2","848":"bf0e924c","955":"49cd4ca2"}[chunkId] + ".chunk.js";
};